import themes from 'scss/_export.module.scss'

export const getThemeColor = (mode: string, colorCode: string): string => {
  const key = `${mode}-${colorCode}`
  return themes[key]
}
